import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useState, useEffect } from "react";
import RuleEngineBackend from "../../services/RuleEngineBackend";
import PPUtils from "../../../utils/PPUtils";
import RuleHistoryMessageView from "../components/RuleHistoryMessageView";
import { formatHistoryType } from "../utils/ruleHistoryFormatter";

function formatHistoryDate(value) {
     if (!value) {
          return "";
     }
     try {
          let date;
          if (Array.isArray(value)) {
               const [year, month, day, hour = 0, minute = 0, second = 0] = value;
               date = new Date(year, (month || 1) - 1, day || 1, hour, minute, second);
          } else {
               date = new Date(value);
          }
          if (isNaN(date.getTime())) {
               return String(value);
          }
          return date.toLocaleString("de-DE", {
               day: "2-digit",
               month: "2-digit",
               year: "numeric",
               hour: "2-digit",
               minute: "2-digit"
          });
     } catch (error) {
          return String(value);
     }
}

function PPPriceManagementRuleHistoryModal({ visible, close, ruleId }) {
     const [history, setHistory] = useState([]);
     const [isLoading, setIsLoading] = useState(false);

     useEffect(() => {
          if (!visible || !ruleId) {
               return;
          }

          let cancelled = false;

          async function loadHistory() {
               setIsLoading(true);
               try {
                    const auth = PPUtils.getLogin();
                    const entries = await RuleEngineBackend.getRuleHistory(auth.token, ruleId);
                    if (!cancelled) {
                         setHistory(Array.isArray(entries) ? entries : []);
                    }
               } catch (error) {
                    if (!cancelled) {
                         setHistory([]);
                    }
               } finally {
                    if (!cancelled) {
                         setIsLoading(false);
                    }
               }
          }

          loadHistory();

          return () => {
               cancelled = true;
          };
     }, [visible, ruleId]);

     const userBody = (row) => row.ppUser?.name || row.ppUser?.username || "—";
     const typeBody = (row) => formatHistoryType(row.type);
     const messageBody = (row) => <RuleHistoryMessageView message={row.message} />;
     const dateBody = (row) => formatHistoryDate(row.createDate);

     return (
          <Dialog
               header={`Regel-Verlauf${ruleId ? ` (ID: ${ruleId})` : ""}`}
               visible={visible}
               style={{ width: "min(92vw, 1100px)", maxHeight: "85vh" }}
               contentStyle={{ overflow: "auto" }}
               onHide={close}
          >
               {isLoading ? (
                    <div className="text-center p-4">
                         <output className="spinner-border">
                              <span className="visually-hidden">Laden...</span>
                         </output>
                    </div>
               ) : (
                    <DataTable
                         value={history}
                         emptyMessage="Keine Verlaufseinträge vorhanden."
                         paginator={history.length > 10}
                         rows={10}
                         size="small"
                         stripedRows
                         className="pp-rule-history-table"
                    >
                         <Column header="Benutzer" body={userBody} style={{ width: "12rem" }} />
                         <Column header="Typ" body={typeBody} style={{ width: "9rem" }} />
                         <Column header="Änderungen" body={messageBody} />
                         <Column header="Datum" body={dateBody} style={{ width: "10rem" }} />
                    </DataTable>
               )}
          </Dialog>
     );
}

export default PPPriceManagementRuleHistoryModal;
